import { ColDef, themeAlpine } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { DateTime } from "luxon";
import { useMemo } from "react";

import { IgTableWrapper } from "@intelligems/ig-theme";
import { OrganizationMeterAppUsageRecordDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { DecimalFormat } from "@src/features/admin/components/utils";
import { theme } from "@src/theme";

interface ShopifyChargeTableProps {
  events: OrganizationMeterAppUsageRecordDto[];
}

const myTheme = themeAlpine.withParams({
  fontFamily: theme.typography.fontFamily,
});

export const ShopifyChargeTable = ({ events }: ShopifyChargeTableProps) => {
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
    };
  }, []);

  const columnDefs: ColDef<OrganizationMeterAppUsageRecordDto>[] = useMemo(
    () => [
      {
        headerName: "Created At",
        field: "createdAtTs",
        valueGetter: (params) => {
          return DateTime.fromMillis(
            params.data?.createdAtTs || 0
          ).toLocaleString(DateTime.DATETIME_SHORT);
        },
      },
      {
        headerName: "Amount",
        field: "price",
        valueFormatter: (params) => {
          return DecimalFormat.format(params.value);
        },
      },
    ],
    []
  );

  return (
    <Grid
      item
      sx={{
        marginTop: "10px",
        width: "100%",
        "& .ag-center-cols-clipper": {
          minHeight: "100px !important",
        },
      }}
    >
      <IgTableWrapper minHeight={"100px"} height={null}>
        <AgGridReact<OrganizationMeterAppUsageRecordDto>
          theme={myTheme}
          rowData={events}
          domLayout={"autoHeight"}
          defaultColDef={defaultColDef}
          columnDefs={columnDefs}
          headerHeight={25}
          suppressCellFocus={true}
        />
      </IgTableWrapper>
    </Grid>
  );
};
